import { Icon, Text } from '@saasalerts/ui'
import React, { forwardRef, InputHTMLAttributes } from 'react'
import { IField } from './types'
import { AllowedExtensions } from '@/utils/constants'
import { faImage } from '@awesome.me/kit-e270131d0a/icons/classic/regular'

export const ImageField = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement> & Partial<IField>
>(({ label, description, ...props }, ref) => {
  return (
    <div>
      <Text as="label" className="block text-sm font-medium text-gray-700">
        {label}
      </Text>
      <label
        htmlFor={props.name}
        className={`relative cursor-pointer bg-white`}
      >
        <div className="mt-1 flex justify-center rounded-md border-2 border-dashed border-gray-300 px-6 pb-6 pt-5 dark:border-gray-800">
          <div className="space-y-1 text-center">
            <Icon size="2x" color="disabled" icon={faImage} />
            <Text>
              <Text as="span">{description}</Text>
              <input
                ref={ref}
                id={props.name}
                name={props.name}
                type="file"
                className="sr-only"
                {...props}
              />
            </Text>
            <Text size="sm">
              Only upload
              {` ${AllowedExtensions.join(', ')}`} image. Max image size - 250KB
              <br />
              Recommended dimensions are 256px x 256px (square) and 640px x
              256px (rectangle).
            </Text>
          </div>
        </div>
      </label>
    </div>
  )
})
